<template>
	<div id="preview" v-loading="loading" :class="[{expand: expand}]">

		<nav>

			<el-button-group>
				<el-button
					icon="el-icon-view"
					@click="showDoc()"
					title="Ver documento"
					/>
				<el-button
					@click="expand = !expand"
					:disabled="loading"
					:type="expand ? 'primary': 'default'"
					icon="el-icon-full-screen"
					title="Maximizar"/>
				<el-button
					v-if="embedVisor"
					@click="descargar"
					:disabled="loading"
					icon="el-icon-download"
					title="Descargar"/>
				<el-button
					v-if="!recargar && implementado"
					@click="zoom = 1, x = 0, y = 0, lastX = 0, lastY = 0"
					:disabled="loading"
					icon="el-icon-refresh"
					title="Recargar"/>
			</el-button-group>

			<div class="zoom" v-if="!recargar && implementado">
				<i class="el-icon-zoom-out"></i>

				<el-slider
					:show-tooltip="false"
					v-model="zoom"
					:disabled="loading"
					:min="0.25"
					:max="1.75"
					:step="0.25"
					show-stops/>

				<i class="el-icon-zoom-in"></i>
			</div>

			<div v-if="!recargar && implementado" class="page">
				<el-button
					:disabled="loading || (paginador.pagina <= 1)"
					@click="anterior"
					type="text"
					icon="el-icon-arrow-left"/>

				<div>{{ paginador.pagina }}</div>

				<el-button
					:disabled="loading || (paginador.pagina >= paginador.paginas)"
					@click="siguiente"
					type="text"
					icon="el-icon-arrow-right"/>
			</div>
			<el-button
				v-else-if="recargar && implementado"
				title="Recargar"
				:disabled="loading"
				@click="cargarPreview(true)"
				icon="el-icon-refresh"/>

		</nav>

		<template v-if="!error">	

			<div ref="contenedor" class="preview-contenedor">

				<canvas
					v-if="implementado && !recargar"
					ref="canvas"
					:style="{
					'transform-origin': 0 + 'px ' + 0  + 'px',
					'transform': `scale(${scale}) translate(${x}px, ${y}px)`,
					'top': 0,
				}"
				></canvas>
				<div v-else class="no-data">
					<img :src="require(`@/assets/noresults.svg`)">
					<p>Previsualización no disponible</p>
					<el-button
					v-if="recargar"
					title="Recargar"
					:disabled="loading"
					@click="cargarPreview(true)"
					type="primary"
					style="margin-top: 20px"
					icon="el-icon-refresh">
						Recargar
					</el-button>
				</div>

			</div>

		</template>

		<div v-else class="no-data">
			<img :src="require(`@/assets/noresults.svg`)">
			<p>Previsualización no disponible</p>
		</div>

	</div>
</template>

<script>
	import Hammer from 'hammerjs'
	import { previsualizarElemento, recargarPrevisualizarElemento, descargarElemento, getUrl } from '../api/api.js'
	import { debug } from '../config.js'

	export default {
		name: 'Preview',
		props: {
			currentObject: Object,
			close: {
				type: Boolean,
				default: true
			},
			embedVisor: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
				hammerCargado: false,
				x: 0,
				y: 0,
				lastX: 0,
				lastY: 0,
				originalScale: 1,
				scale: 1,
				currentZoom: 1,
				loading: false,
				error: false,
				zoom: 1,
				paginador: {
					pagina: 1,
					paginas: 1
				},
				recargar: false,
				implementado: true,
				actions: [
					{
						name: "Sincronizar",
						callback: () => {
							alert("Sincronizar")
						}
					},
					{
						name: "Descargar",
						callback: () =>{
							this.descargar()
						}
					},
				],
				expand: false
			}
		},
		watch: {
			zoom (val) { this.changeZoom(val) },

			currentObject: {
				// This will let Vue know to look inside the array
				deep: true,

				// We have to move our method to a handler field
				async handler(newCurrentObject) {
					await this.cargarPreview();
				}
			}
		},
		mounted () { this.cargarPreview() },
		methods: {
			showDoc() {
				this.openwindow(`/SiDMS.DOC/?id=${this.currentObject.id}&accesstoken=${localStorage.getItem('accessToken')}`, '_blank')
			},

			anterior () {

				this.paginador.pagina--

				this.cargarPreview()

			},

			async cargarPreview (recargar = false) {

				if (this.loading) return

				this.loading = true

				this.error = false

				this.zoom = 1

				try {

					let data = {}

					if (recargar){
						data = await recargarPrevisualizarElemento(this.currentObject.id, this.paginador.pagina)
					} else {

						if (debug) {

							data = await (await fetch('/preview.json', {
								method: 'GET'
							})).json()

						} else {

							data = await previsualizarElemento(this.currentObject.id, this.paginador.pagina)
						}
					}

					data = data.data

					const image = new Image()

					this.paginador = {
						pagina: data.pagina,
						paginas: data.paginas
					}

					this.recargar = data.recargar

					this.implementado = data.implementado

					if (this.implementado && !this.recargar) {

						image.crossOrigin = 'anonymous'

						image.src = `data:image/jpeg;base64,${ data.preview }`

						image.addEventListener('load', () => {

							this.$refs.canvas.width = image.width

							this.$refs.canvas.height = image.height

							this.fitPageWithScale()
							this.scale = this.originalScale
							this.$refs.canvas.getContext('2d').drawImage(image, 0, 0)

						})

						this.iniciarHammer()

					}

					this.loading = false

				} catch (err) {

					// if(err && err.response && err.response.data && err.response.data.message){
					// 	this.$toastr.error(err.response.data.message)
					// }

					this.error = true
					this.expand = false

					this.loading = false

					throw err

				}

			},

			changeZoom (scale) {

				this.scale = this.originalScale * scale

				this.lastX = 0

				this.lastY = 0

				this.x = 0

				this.y = 0

				this.currentZoom = scale

			},

			iniciarHammer () {

				if (this.hammerCargado) return

				const mc = new Hammer.Manager(this.$refs.contenedor)

				const singlepan = new Hammer.Pan({
					event: 'pan',
					direction: Hammer.DIRECTION_ALL,
					threshold: 5,
					pointers: 1
				})

				const multipan = new Hammer.Pan({
					event: 'multipan',
					direction: Hammer.DIRECTION_ALL,
					threshold: 5,
					pointers: 2
				})

				mc.add(singlepan)

				mc.add(multipan)

				singlepan.recognizeWith(multipan)

				multipan.requireFailure(singlepan)

				let fallbackX = this.x, fallbackY = this.y
				mc.on('pan', ev => {

					this.x = -(this.lastX - ev.deltaX / this.scale)

					this.y = -(this.lastY - ev.deltaY / this.scale)

				})

				mc.on('panend', () => {

					this.lastX = -this.x

					this.lastY = -this.y

					//let alturaContenedor = parseInt(getComputedStyle(this.$refs.contenedor).getPropertyValue('height'))
					let anchuraContenedor = parseInt(getComputedStyle(this.$refs.contenedor).getPropertyValue('width'))
					let alturaImagen = this.$refs.canvas.height;
					let anchuraImagen = this.$refs.canvas.width;

					if(this.x > (anchuraContenedor + anchuraImagen)  || this.x < (- anchuraImagen)
					|| this.y > (alturaImagen) || this.y < (- alturaImagen)){
						this.x = fallbackX;
						this.y = fallbackY;
						this.lastX = fallbackX;
						this.lastY = fallbackY;
					}
				})

				this.hammerCargado = true

			},

			siguiente () {

				this.paginador.pagina++

				this.cargarPreview()

			},

			fitPageWithScale(){
				let alturaContenedor = parseInt(getComputedStyle(this.$refs.contenedor).getPropertyValue('height'))
				let anchuraContenedor = parseInt(getComputedStyle(this.$refs.contenedor).getPropertyValue('width'))
				let alturaImagen = this.$refs.canvas.height;
				let anchuraImagen = this.$refs.canvas.width;
				if(alturaImagen >= anchuraImagen){
					this.originalScale = alturaContenedor/alturaImagen
				} else {
					this.originalScale = anchuraContenedor/anchuraImagen
				}
			},

			async descargar () {

				if(!this.currentObject && !this.currentObject.id && this.currentObject === -1 && this.currentObject.id === -1){
					return false
				}
				try {
					const { data } = await descargarElemento(this.currentObject.id ? this.currentObject.id : this.selectedItem)

					const url = getUrl()

					location.href = url + 'acceso/externo/?token=' + data.token + '&id=' + data.fichero

					this.showModal = -1

				} catch(e) {
					// this.$toastr.error(e.response.data.message);
				}

			},

		}
	}
</script>

<style lang="scss">

	#preview {
		position: relative;
		//background-color: #fafafa;
		border-radius: 3px;
		//border: 1px solid #dcdfe6;
		height: calc(100% - 2px);

		&.expand {
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			z-index: 9;
		}

		nav {
			background-color: white;
			display: flex;
			align-items: center;
			border-bottom: 1px solid #dcdfe6;
			padding: 10px;
			border-radius: 3px;
			flex-flow: row;

			.page {
				display: flex;
				align-items: center;
				> div {
					padding: 0px 5px;
				}
			}

			.zoom {
				display: flex;
				align-items: center;
				flex-grow: 1;
				.el-slider {
					width: 130px;
				}
				i {
					padding: 5px 10px;
				}
			}
		}

		.preview-contenedor {
			position: relative;
			overflow: hidden;
			height: calc(100% - 61px);
			canvas {
				position: absolute;
			}
		}
	}
</style>
